import React from "react";
import PackageDetailsWrap from "./PackageDetailsWrap";

function OnlineWorkshop(props) {
    const { item_id } = props.match.params;
    return (
        <>
            <PackageDetailsWrap item_id={item_id} ctype="online" />
        </>
    )
}

export default OnlineWorkshop
